import { render, staticRenderFns } from "./BuddyDigitalSignageScreenshots.vue?vue&type=template&id=ebb6c482&scoped=true"
import script from "./BuddyDigitalSignageScreenshots.ts?vue&type=script&lang=ts&external"
export * from "./BuddyDigitalSignageScreenshots.ts?vue&type=script&lang=ts&external"
import style0 from "./BuddyDigitalSignageScreenshots.scss?vue&type=style&index=0&id=ebb6c482&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb6c482",
  null
  
)

export default component.exports